import React from "react";
import { Link, useTranslation } from "gatsby-plugin-react-i18next";
import { useI18nLink } from "../../hooks/useI18nLink";
import { Button } from "../Button";

interface JoinHeroCtaProps {
  smCenter?: boolean;
  text?: string;
}

export const JoinHeroCta: React.FunctionComponent<JoinHeroCtaProps> = ({
  smCenter = true,
  text,
}) => {
  const { t } = useTranslation();
  const i18nLink = useI18nLink();

  return (
    <Button
      to={i18nLink("/lavora-con-noi/") + "#job-positions"}
      label={text || t("join:hero.cta.jobPositions")}
      variant="secondary"
    />
  );
};
